import { useMemo } from 'react';
import useContext from '../../../../hooks/useContext';
import { ConfigurationContext } from '../providers/ConfigurationProvider';

export default (type: ConfigurationType, items: IConfigurationItem[]) => {
  const { selection } = useContext(ConfigurationContext);
  const currentValue = selection?.[type];
  return useMemo(() => items.find((i) => i.id === currentValue), [items, currentValue]);
};
